// extracted by mini-css-extract-plugin
export default {"expiredmessage":"expiredmessage_expiredmessage__YGlsj","expiredmessage__text":"expiredmessage_expiredmessage__text__21Rdr"};